import { PasswordField as SerendiePasswordField } from "@serendie/ui";
import { BaseComponent } from "../../Core/BaseComponent/BaseComponent";
import { JSX } from "react";
import "./Styles.scss";
import React from "react";
import { components } from "../../Components";

export class PasswordField extends BaseComponent<IPasswordFieldProps, IPasswordFieldState>
{
    private inputElement: HTMLInputElement | null = null;
    public static requiredLabel = '*';

    private ref(inputElement: HTMLInputElement | null): void
    {
        this.inputElement = inputElement;
        const { ref } = this.props;

        if (typeof ref == 'function')
        {
            ref(inputElement);
        }
        else if (ref)
        {
            ref.current = inputElement;
        }
    }

    public componentDidMount(): void
    {
        this.updateRequiredLabel();
    }

    public componentDidUpdate(): void
    {
        this.updateRequiredLabel();
    }

    private updateRequiredLabel(): void
    {
        const requiredContainer = this.inputElement?.parentElement?.parentElement?.querySelector('label')?.querySelector('span');
        if (!requiredContainer)
        {
            return;
        }
        requiredContainer.innerText = this.props.requiredLabel ?? PasswordField.requiredLabel;
    }

    public render(): JSX.Element
    {
        return <SerendiePasswordField
            {...this.props}
            ref={e => this.ref(e)}
            className={`${this.props.className ?? ''} serendie-passwordfield`}
        />
    }
}

export interface IPasswordFieldProps extends React.ComponentProps<typeof SerendiePasswordField>
{
    requiredLabel?: string;
}

export interface IPasswordFieldState { }
